import _ from 'lodash';
import { connect } from 'react-redux';
import { get, add } from '../modules/resource';
import { showErrors } from '../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const resourceId = (ownProps.resourceId)
		? ownProps.resourceId
		: _.get(ownProps, ['match', 'params', 'resourceId']);
	const resource = _.get(state.maps, ['resource', resourceId]);

	return {
		resource
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getResource : get,
	addResource : add,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
